export default class Office {
  /**
   * @type {number}
  */
  id;

  /**
   * @type {string}
  */
  storeNum;

  /**
   * @type {string}
  */
  ip;

  /**
   * @type {string}
  */
  userId;

  /**
   * @type {string}
  */
  efin;

  /**
   * @type {string}
  */
  address;

  /**
   * @type {string}
  */
  city;

  /**
   * @type {string}
  */
  state;

  /**
   * @type {string}
  */
  zip;

  /**
   * @type {string}
  */
  phone;

  /**
   * @type {number}
  */
  brand = 1;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.id != null) {
        this.id = opts.id;
      }
      if (opts.storeNum != null) {
        this.storeNum = opts.storeNum;
      }
      if (opts.ip != null) {
        this.ip = opts.ip;
      }
      if (opts.userId != null) {
        this.userId = opts.userId;
      }
      if (opts.efin != null) {
        this.efin = opts.efin;
      }
      if (opts.address != null) {
        this.address = opts.address;
      }
      if (opts.city != null) {
        this.city = opts.city;
      }
      if (opts.state != null) {
        this.state = opts.state;
      }
      if (opts.zip != null) {
        this.zip = opts.zip;
      }
      if (opts.phone != null) {
        this.phone = opts.phone;
      }
      if (opts.brand != null) {
        this.brand = opts.brand;
      }
    }
  }
}
